(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/result.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/result.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const useDrawResults = svs.components.tipsen.hooks.useDrawResults;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$sport = svs.components.sportinfo.common.matchState,
  getIsCancelled = _svs$components$sport.getIsCancelled,
  getIsOngoing = _svs$components$sport.getIsOngoing,
  getIsFinished = _svs$components$sport.getIsFinished,
  getIsPostponedOrDelayed = _svs$components$sport.getIsPostponedOrDelayed;
const _React = React,
  useMemo = _React.useMemo;
const MatchResultTypes = svs.components.sport.tipsenShared.constants.MatchResultTypes;
const Result = _ref => {
  let drawEvent = _ref.drawEvent,
    drawNumber = _ref.drawNumber,
    productId = _ref.productId;
  const _useDrawResults = useDrawResults({
      productId,
      drawNumber
    }),
    data = _useDrawResults.data;
  const _data = _slicedToArray(data, 1),
    currentDrawResult = _data[0];
  const eventNumber = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber) || undefined;
  const currentMatchId = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.matchId) || undefined;
  const sportEvent = useSelector(state => selectSportEvent(state, currentMatchId));
  const isFinished = currentDrawResult ? currentDrawResult[eventNumber - 1].matchResultState >= MatchResultTypes.VERIFIED : false;
  const isOngoing = !isFinished && sportEvent ? getIsOngoing(sportEvent.sportEventStatus) || getIsFinished(sportEvent.sportEventStatus) : undefined;
  const isDelayed = !isFinished && sportEvent ? getIsPostponedOrDelayed(sportEvent.sportEventStatus) : undefined;
  const isCancelledBySportEvent = sportEvent ? getIsCancelled(sportEvent.sportEventStatus) : undefined;
  const result = useMemo(() => {
    if (currentDrawResult && (isOngoing || isFinished) && !isDelayed) {
      const resultForCurrentEvent = currentDrawResult[eventNumber - 1];
      const isCancelledByDrawResult = resultForCurrentEvent === null || resultForCurrentEvent === void 0 ? void 0 : resultForCurrentEvent.cancelled;
      let formattedResult = resultForCurrentEvent ? "".concat(resultForCurrentEvent.home, " - ").concat(resultForCurrentEvent.away) : '';
      formattedResult = isCancelledBySportEvent || isCancelledByDrawResult ? '-' : formattedResult;
      return formattedResult;
    }
    return undefined;
  }, [currentDrawResult, eventNumber, isCancelledBySportEvent, isDelayed, isFinished, isOngoing]);
  if (!result) {
    return null;
  }
  return React.createElement("div", {
    "aria-hidden": true,
    className: "pg_coupon_static__init__result"
  }, result);
};
setGlobal('svs.components.tipsen.couponStatic.Result', Result);

 })(window);